<script setup>
definePage({ meta: { layout: 'empty' } });
const router = useRouter();
onMounted(() => router.replace({ path: '/saju-service', query: { menu: '/overviewNangmanNaming' } }));
</script>

<template><div /></template>
